export const getSizes = {
    big: {
        width: "1.5rem",
        fontSize: ".8125rem",
        lineHeight: "1rem",
    },
    standard: {
        width: "1.25rem",
        fontSize: ".625rem",
        lineHeight: ".75rem",
    },
    small: {
        width: ".625rem",
    },
    tiny: {
        width: ".5rem",
    },
};
export const getColor = ({ value, color, isLabel, theme }) => {
    switch (color) {
        case "default":
            if (isLabel)
                return theme.colors.grey15;
            if (!!value)
                return theme.colors.cd05;
            return theme.colors.cl09;
        case "success":
            return theme.colors.success;
        case "warning":
            if (isLabel)
                return theme.colors.grey15;
            return theme.colors.warning;
        case "error":
            return theme.colors.error;
        case "info":
            if (isLabel)
                return theme.colors.grey15;
            return theme.colors.primaryLight;
        case "accent":
            if (isLabel)
                return theme.colors.grey15;
            return theme.colors.cl23;
        default:
            if (isLabel)
                return theme.colors.grey15;
            return theme.colors.grey06;
    }
};
export const getStyle = ({ value, label, size }) => {
    const dimension = getSizes[size].width;
    const radius = size === "big" ? "1rem" : ".625rem";
    const padding = size === "big" ? "0.25rem 0.5rem" : "0 .25rem 1px";
    if (label && !value)
        return `height: 0.5rem; width: 0.5rem; margin:0 0.5rem; border-radius: 50%`;
    return `height: ${dimension}; min-width: ${dimension}; border-radius: ${radius}; padding: ${padding}`;
};
export const isBig = (_, value) => {
    return !!value;
};
